import { render, staticRenderFns } from "./SplitTest.vue?vue&type=template&id=1c3deb1c&scoped=true"
import script from "./SplitTest.vue?vue&type=script&lang=js"
export * from "./SplitTest.vue?vue&type=script&lang=js"
import style0 from "./SplitTest.vue?vue&type=style&index=0&id=1c3deb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3deb1c",
  null
  
)

export default component.exports